import styled from '@emotion/styled';
import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';

export const StyledUl = styled.ul`
  list-style-type: disc;
  color: var(--support-accordion-text-color, ${COLORS3.WHITE_100});
  width: 100%;

  margin: 0 ${SPACING.S24};

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    &:first-of-type {
      margin: 0;
    }
  }

  ${MEDIA_QUERY.TABLET} {
    width: 100%;
    margin: 0 ${SPACING.S16};
  }
`;
export const StyledLi = styled.li`
  margin-bottom: ${SPACING.MD};

  a {
    font-weight: ${FONT.FONT_WEIGHT_MEDIUM};
  }
`;
